import * as React from 'react';
import { useContext } from 'react';

import type { CareerRolesCollectionType } from '@coursera-web/cds-labs';

export type RelatedRolesContextType = {
  loading: boolean;
  collection?: CareerRolesCollectionType;
};

const RelatedRolesContext = React.createContext<RelatedRolesContextType | undefined>(undefined);

export const useRelatedRoles = () => {
  return useContext(RelatedRolesContext);
};

export default RelatedRolesContext;
